import React, { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { Drawer, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router';
import { useMediaQuery } from 'react-responsive';
import UserContext from '../../contexts/UserContext';

import SearchSuffix from '../../pages/landing/components/SearchSuffix';
import { CloseIcon } from '../icons';
import Logo from '../topbar/Logo';

import './styles.scss';
import { brandingConfig } from '../../config';

const SearchDrawer = (props) => {
  const history = useHistory();
  const isMobile = useMediaQuery({ maxWidth: 567 });

  const searchBtn = useRef(null);

  const { visible, onClose, setSearchVisible } = props;

  const {
    globalSearch,
    setGlobalSearch,
    setSearchActive,
  } = useContext(UserContext);

  const onChange = (e) => setGlobalSearch(e.target.value);

  const onEnter = (e) => {
    if (e.key === 'Enter') {
      searchBtn?.current.click();
    }
  };

  const onSearch = () => {
    setSearchActive(true);
    setSearchVisible(false);
    history.push({
      pathname: '/search',
      search: `?query=${globalSearch}`,
    });
  };

  return (
    <Drawer
      className="search-drawer"
      placement="top"
      closable
      closeIcon={(
        <span style={{ color: 'rgb(230, 230, 230)' }}>
          <CloseIcon />
        </span>
      )}
      onClose={onClose}
      mask={isMobile}
      maskClosable={isMobile}
      open={visible}
      title={<Logo />}
    >
      <label
        className="h2"
        style={{
          letterSpacing: 1,
          paddingBottom: 19,
        }}
      >
        What are you looking for?
      </label>
      <Input
        placeholder="Search Seagull"
        prefix={<SearchOutlined style={{ marginRight: 10 }} />}
        value={globalSearch}
        onChange={onChange}
        onEnter={onEnter}
        style={{
          fontFamily: brandingConfig.fonts.bodyName,
        }}
        suffix={(
          <SearchSuffix
            onClick={onSearch}
          />
        )}
      />
    </Drawer>
  );
};

SearchDrawer.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  setSearchVisible: PropTypes.func,
};

SearchDrawer.defaultProps = {
  visible: false,
  onClose: () => {},
  setSearchVisible: () => {},
};
export default SearchDrawer;
